import { render } from "./RequestedItems.vue?vue&type=template&id=05fa8cbe&ts=true"
import script from "./RequestedItems.vue?vue&type=script&lang=ts"
export * from "./RequestedItems.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__